import {del} from '../utils'
import {getActiveClient} from "../authentication/utils";

export default host => id => del(`${host}/clients/${getActiveClient()}/speakers/${id}/favorite`)
